import styled from 'styled-components';

export const Typography = {
  H1: styled.h1`
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 38px;
    color: ${({ theme }) => theme.algoanBlue};
    margin: 0;
  `,
  H2: styled.h2`
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    color: ${({ theme }) => theme.algoanBlue};
    margin: 0;
  `,
  H3: styled.h3`
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme }) => theme.algoanBlue};
    margin: 0;
  `,
};
